import { Alert, Box, Button, Tooltip, Typography } from "@mui/material"
import { useEffect, useState } from "react"

import AddCircleIcon 	from '@mui/icons-material/AddCircle';
import LoopIcon 		from '@mui/icons-material/Loop';

import useInternalFetch	from "../../api/apiInternal"
import Loading 			from "../Loading";
import ForumPost		from "./ForumPost"
import ForumThread		from "./ForumThread"
import config 			from "../../common/Config";

const Forum = (props) => {

	const internalFetch 							= useInternalFetch()

	const [newPostOpen, setNewPostOpen]		 		= useState(false)
	const [page, setPage]							= useState(0)
	// const [pageSize, setPageSize]					= useState(5)
	const [posts, setPosts]							= useState([])
	const [postCount, setPostCount]					= useState()
	const [isLoading, setIsLoading]					= useState(true)
	const [hasAlert, setHasAlert]					= useState(false)
	const [alertSeverity, setAlertSeverity]			= useState()
	const [alertMessage, setAlertMessage]			= useState()

	const pageSize = 5

	useEffect(() => {
		getPosts(page)
	},[props.companyId])

	// Busca posts
	const getPosts = (currentPage) => {
		let url

		if (props.companyId) {
			url = config.apiUrl +'/api/forum/'+ props.companyId +'?limit='+ pageSize +'&offset='+ currentPage
		}
		else {
			url = config.apiUrl +'/api/forum?limit='+ pageSize +'&offset='+ currentPage
		}

		// Busca os posts de acordo com a paginacao
		internalFetch(url)
		.then(fetch => {
			if (!fetch.status || fetch.status === 200) {
				setIsLoading(false)
				setPostCount(fetch.data.count)

				// Adiciona apenas posts que já não estão no array de posts
				fetch.data.rows.map(row => {
					setPosts(p => {
						const postIndex = p.findIndex(post => post.id === row.id)
						
						// Se não esta no array, adicionar
						// Senão, atualiza
						if (postIndex < 0) {
							p.push(row)
						}
						else {
							p[postIndex] = row
						}

						return p
					})
				})
			}

			// Ordena array pelo ID decrescente
			//setPosts(p => p.sort((a,b) => b.id - a.id))
		})
	}

	// Remove Post
	const deletePost = async (postId) => {
		const options = {
			method : 'DELETE',
			headers : {'content-type' : 'application/json; charset=utf-8'}
		}

		internalFetch(config.apiUrl +'/api/forum/'+ postId, options)
		.then(() => {
			// Remove o postID da lista para evitar reload
			// Também procura nas replies para remoção			
			setPosts(posts.filter(p => p.id !== postId).map(p1 => {return {...p1, replies : p1.replies.filter(p2 => p2.id !== postId)}}))
		})
	}

	// Adiciona novo post ou comentario
	const addPost = async (postId, title, category, text, companyId, parentId) => {
		const options =  {
			method : 'POST',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			},
			body : JSON.stringify({
				post : {
					postId		: postId,
					title		: title,
					category	: category,
					text 		: text,
					companyId 	: companyId,
					parentId	: parentId
				}
			})
		}

		return internalFetch(config.apiUrl +'/api/forum', options)
		.then(fetch => {
			// Caso tenha o post tenha sido criado, atualiza pagina
			// Senao, caso tenha acontecido erro, mostra alerta e atualiza pagina
			if (fetch.status === 200 ) {
				setIsLoading(true)
				getPosts(0)
			}
			else {
				setHasAlert(true)
				setAlertSeverity('error')
				setAlertMessage('Erro! Este tópico foi removido!')

				handleReload()
			}			
		})
	}

	// Avança paginaçào
	const handleLoadMore = () => {
		setIsLoading(true)

		setPage(page + pageSize)
		getPosts(page + pageSize)
	}

	// Atualiza dados
	const handleReload = () => {
		setIsLoading(true)
		setPosts(p => [])
		setPage(0)
		getPosts(0)
	}

	if (!posts) return <Loading/>

	return (

		<Box sx={{pt: 1, paddingX: 2, marginBottom: 5, overflowX: 'auto'}}>

			{hasAlert ? (
				<Alert severity={alertSeverity} onClose={() => setHasAlert(false)}>{alertMessage}</Alert>
			) : null}
			
			<Box display={'flex'}>
				<Typography variant="h5" fontWeight={800} display={'flex'} alignItems={'center'} flex={1}>Comunidade</Typography>
				<Tooltip title="Atualizar"><LoopIcon fontSize="large" color="primary" onClick={handleReload} sx={{cursor: 'pointer'}}/></Tooltip>
				<Tooltip title="Novo Tópico"><AddCircleIcon fontSize="large" color="primary" onClick={() => setNewPostOpen(!newPostOpen)} sx={{cursor: 'pointer'}}/></Tooltip>
			</Box>
			
			<ForumPost companyId={props.companyId} isOpen={newPostOpen} setIsOpen={setNewPostOpen} onPost={addPost} />

			{ posts.length > 0 ? ( 
				posts.map(p => <ForumThread key={p.id} post={p} onPost={addPost} onDelete={deletePost}/>)
			):(
				<Typography align="center">Ainda não há nenhum post.</Typography>
			)}		

			{isLoading ? (
				<Box sx={{mt: 1}} width={'100%'} marginY={1} borderRadius={1} boxShadow={2}>
					<Loading/>
				</Box>
			) : null}

			{ page * pageSize < postCount ? (
				<Button fullWidth variant="contained" onClick={handleLoadMore}>Carregar mais</Button>
			) : null }
		</Box>

	)	
}

export default Forum